import React from "react";
import { useNavigate } from "react-router-dom";

const DashboardAnnouncement = ({ stats }) => {
  const navigate = useNavigate();

  // Get webinar data from stats, with fallback values
  const webinar = stats?.webinar || null;

  // Format date and time for display
  const formatDateTime = () => {
    if (!webinar?.rawDate || !webinar?.rawTime) {
      return webinar?.date || "00/00/00 @ 10am pst";
    }

    try {
      const date = new Date(webinar.rawDate);
      const [hours, minutes] = webinar.rawTime.split(':');

      // Format date as MM/DD/YY
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2);

      // Format time as 12-hour with AM/PM
      let hour = parseInt(hours);
      const ampm = hour >= 12 ? 'pm' : 'am';
      hour = hour % 12 || 12;

      return `${month}/${day}/${year} @ ${hour}:${minutes} ${ampm} pst`;
    } catch (error) {
      console.error('Error formatting date:', error);
      return webinar?.date || "00/00/00 @ 10am pst";
    }
  };

  const handleCardClick = (e) => {
    e.preventDefault();
    if (webinar) {
      if (webinar.link) {
        // If external link exists, open in new tab
        window.open(webinar.link, '_blank');
      } else {
        // Otherwise, navigate to internal details page
        console.log('Navigating to webinar details:', webinar);
        navigate('/host/webinar-details', { state: { webinar } });
      }
    }
  };

  return (
    <div
      onClick={handleCardClick}
      className="p-4 rounded-4 h-100"
      style={{
        background: "linear-gradient(#61dde9 0%, #a685e2 100%)",
        color: "#fff",
        cursor: 'pointer',
        transition: 'transform 0.2s ease-in-out',
      }}
      onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
      onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleCardClick(e);
        }
      }}
    >
      <div className="lato-bold-24 mb-2" style={{ fontSize: '20px', lineHeight: '1.3' }}>
        {(() => {
          const plain = (webinar?.description || "").replace(/<[^>]*>/g, '').trim();
          return plain.length > 100 ? plain.slice(0, 100) + '…' : (plain || "Upcoming");
        })()}
      </div>
      <div className="lato-medium-16">
        {formatDateTime()}
      </div>
    </div>
  );
};

export default DashboardAnnouncement;